<!-- Desktop `skelService`; tablet/mobile from 768pt / 390pt prototypes. -->
<div class="delivery-service-skeleton" aria-hidden="true" data-testid="delivery-service-skeleton">
  <!-- Desktop ≥1200: three date columns + signature. -->
  <div class="delivery-service-skeleton__desktop">
    <app-skeleton-block class="delivery-service-skeleton__title" width="420" height="30" />
    <app-skeleton-block
      class="delivery-service-skeleton__subtitle"
      width="168"
      height="11"
      tone="secondary"
    />

    <div class="delivery-service-skeleton__columns">
      @for (column of columnPlaceholders; track column) {
        <div class="delivery-service-skeleton__column">
          <app-skeleton-block height="62" radius="shell" tone="emphasis" />
          @for (card of cardPlaceholders; track card) {
            <div class="delivery-service-skeleton__card">
              <app-skeleton-block width="60%" height="15" />
              <app-skeleton-block width="78%" height="10" tone="secondary" />
              <app-skeleton-block width="66%" height="14" />
            </div>
          }
        </div>
      }
    </div>

    <app-skeleton-block
      class="delivery-service-skeleton__guarantees"
      width="300"
      height="11"
      tone="secondary"
    />

    <div class="delivery-service-skeleton__signature">
      <app-skeleton-block width="460" height="22" />
      <div class="delivery-service-skeleton__signature-row">
        <div class="delivery-service-skeleton__signature-copy">
          <app-skeleton-block height="11" tone="secondary" />
          <app-skeleton-block width="70%" height="11" tone="secondary" />
        </div>
        <app-skeleton-block
          class="delivery-service-skeleton__signature-select"
          width="340"
          height="52"
          radius="card"
        />
      </div>
    </div>
  </div>

  <!-- Tablet 768–1199: pills, arriving banners, four rows, signature, actions. -->
  <div class="delivery-service-skeleton__tablet">
    <div class="delivery-service-skeleton__centered">
      <app-skeleton-block width="430" height="30" />
    </div>
    <div class="delivery-service-skeleton__centered">
      <app-skeleton-block width="170" height="11" tone="secondary" />
    </div>

    <div class="delivery-service-skeleton__date-pills">
      @for (pill of datePillPlaceholders; track pill) {
        <app-skeleton-block
          width="132"
          height="38"
          radius="circle"
          [tone]="pill === 0 ? 'emphasis' : 'secondary'"
        />
      }
    </div>

    <app-skeleton-block
      class="delivery-service-skeleton__tablet-arriving"
      height="62"
      radius="shell"
      tone="emphasis"
    />
    <app-skeleton-block height="32" radius="shell" tone="emphasis" />

    @for (card of tabletCardPlaceholders; track card) {
      <div class="delivery-service-skeleton__tablet-card">
        <div class="delivery-service-skeleton__tablet-card-copy">
          <app-skeleton-block width="196" height="16" />
          <app-skeleton-block width="156" height="11" tone="secondary" />
        </div>
        <div class="delivery-service-skeleton__tablet-card-aside">
          <app-skeleton-block width="114" height="10" tone="secondary" />
          <app-skeleton-block width="92" height="18" />
        </div>
      </div>
    }

    <app-skeleton-block
      class="delivery-service-skeleton__tablet-note"
      width="470"
      height="11"
      tone="secondary"
    />
    <app-skeleton-block width="420" height="11" tone="secondary" />

    <div class="delivery-service-skeleton__signature delivery-service-skeleton__signature--tablet">
      <app-skeleton-block width="340" height="22" />
      <div class="delivery-service-skeleton__signature-row">
        <div class="delivery-service-skeleton__signature-copy">
          <app-skeleton-block height="11" tone="secondary" />
          <app-skeleton-block width="74%" height="11" tone="secondary" />
        </div>
        <app-skeleton-block
          class="delivery-service-skeleton__signature-select"
          width="314"
          height="56"
          radius="card"
        />
      </div>
    </div>
  </div>

  <!-- Mobile ≤767: centered title, pills, arriving banner, five cards, footer lines. -->
  <div class="delivery-service-skeleton__mobile">
    <div class="delivery-service-skeleton__mobile-title">
      <app-skeleton-block width="250" height="30" />
    </div>
    <div class="delivery-service-skeleton__mobile-pills">
      @for (pill of datePillPlaceholders; track pill) {
        <app-skeleton-block
          width="106"
          height="38"
          radius="circle"
          [tone]="pill === 0 ? 'emphasis' : 'secondary'"
        />
      }
    </div>
    <app-skeleton-block
      class="delivery-service-skeleton__mobile-arriving"
      height="66"
      radius="shell"
      tone="emphasis"
    />
    @for (card of mobileCardPlaceholders; track card) {
      <div class="delivery-service-skeleton__mobile-card">
        <app-skeleton-block width="168" height="18" />
        <app-skeleton-block width="196" height="12" tone="secondary" />
        <app-skeleton-block width="214" height="18" />
      </div>
    }
    <div class="delivery-service-skeleton__mobile-footer">
      @for (width of mobileFooterLineWidths; track width; let i = $index) {
        <app-skeleton-block
          [width]="width"
          height="12"
          tone="secondary"
          [class.delivery-service-skeleton__mobile-footer-gap]="i === 2"
        />
      }
    </div>
  </div>
</div>
